var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.077.698 1.665.286a.976.976 0 1 0-1.38 1.38l2.72 2.719A2.6 2.6 0 0 0 2.8 5.4v12.281c0 .72.297 1.41.826 1.918a2.88 2.88 0 0 0 1.994.794h13.393l3.322 3.321a.976.976 0 0 0 1.425-1.33L2.123.747zM4.791 6.17v11.511c0 .212.087.415.243.564.155.15.366.234.586.234H17.1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.832 18.696c.134-.32.205-.663.205-1.015v-9.65a2.66 2.66 0 0 0-.826-1.917 2.88 2.88 0 0 0-1.994-.794H12.54l-1.53-2.205a1 1 0 0 0-.827-.426H6.824l1.914 1.914h.911l1.53 2.205c.184.266.495.426.827.426h8.211c.22 0 .431.084.587.234s.243.352.243.564v8.879z"
}))));
export default SvgEmptyComponent;